const styles = (theme) => ({
  pinContainer: {
    height: 45,
    backgroundColor: theme.color.black_05,
    border: '1px solid rgba(0, 0, 0, 0.13)',
    borderRadius: theme.spacing(0.25),
  },
  pinTitle: {
    color: theme.color.black_33,
  },
  containerMargin: {
    margin: theme.spacing(1, 0, 2.5, 0),
  },
  pinLink: {
    fontSize: 16,
    color: theme.color.teal,
  },
  pinSansLink: {
    fontSize: 16,
  },
});
export default styles;
